module.exports = __webpack_public_path__ + "0803bc21acc674effe3d8d82a2fe7631.png";